module.exports = __webpack_public_path__ + "media/summer_2025_sweepstakes/your-future-is-now-confirmation-lock-up2-a3e83d4a.png";